package dev.lingvo.site.pages.app

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.ui.modifiers.attr
import com.varabyte.kobweb.compose.ui.modifiers.textDecorationLine
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.outline
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.style.selectors.focusVisible
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.LineStyle
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexGrow
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.minWidth
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import dev.lingvo.shared.ActivityDto
import dev.lingvo.shared.AttentionItemDto
import dev.lingvo.shared.AttentionKind
import dev.lingvo.shared.AttentionSeverity
import dev.lingvo.shared.CreditPositionDto
import dev.lingvo.shared.LocaleReadinessDto
import dev.lingvo.shared.OverviewProjectDto
import dev.lingvo.shared.OverviewResponse
import dev.lingvo.shared.ProjectAccentKey
import dev.lingvo.shared.ProjectIconKey
import dev.lingvo.shared.ProjectSummaryDto
import dev.lingvo.shared.WorkLogEntryDto
import dev.lingvo.shared.localeFlagPrefix
import dev.lingvo.shared.localeInfo
import dev.lingvo.site.api.ApiClient
import dev.lingvo.site.api.ApiException
import dev.lingvo.site.api.Async
import dev.lingvo.site.api.loadReloadable
import dev.lingvo.site.components.PlainLinkStyle
import dev.lingvo.site.components.ShellToastHost
import dev.lingvo.site.components.automation.PretranslateConfirm
import dev.lingvo.site.components.automation.PretranslateScope
import dev.lingvo.site.components.automation.jobReceiptHref
import dev.lingvo.site.components.ProgressCell
import dev.lingvo.site.ds.AsyncFailureState
import dev.lingvo.site.ds.LArchiveRestoreIcon
import dev.lingvo.site.ds.LAlert
import dev.lingvo.site.ds.LAlertVariant
import dev.lingvo.site.ds.LAvatar
import dev.lingvo.site.ds.LAvatarSize
import dev.lingvo.site.ds.LBadge
import dev.lingvo.site.ds.LBadgeVariant
import dev.lingvo.site.ds.LBotIcon
import dev.lingvo.site.ds.LButton
import dev.lingvo.site.ds.LButtonSize
import dev.lingvo.site.ds.LButtonVariant
import dev.lingvo.site.ds.LCard
import dev.lingvo.site.ds.LCardLinkStyle
import dev.lingvo.site.ds.LCircleAlertIcon
import dev.lingvo.site.ds.LCircleCheckIcon
import dev.lingvo.site.ds.LCircleXIcon
import dev.lingvo.site.ds.LCommentIcon
import dev.lingvo.site.ds.LCoinsIcon
import dev.lingvo.site.ds.LDivider
import dev.lingvo.site.ds.LEllipsisIcon
import dev.lingvo.site.ds.LEmptyState
import dev.lingvo.site.ds.LEmptyStateIcon
import dev.lingvo.site.ds.LFileIcon
import dev.lingvo.site.ds.LFilterIcon
import dev.lingvo.site.ds.LGlobeIcon
import dev.lingvo.site.ds.LHistoryIcon
import dev.lingvo.site.ds.LIconAction
import dev.lingvo.site.ds.LKeyIcon
import dev.lingvo.site.ds.LLanguagesIcon
import dev.lingvo.site.ds.LListChecksIcon
import dev.lingvo.site.ds.LMenu
import dev.lingvo.site.ds.LMenuEntry
import dev.lingvo.site.ds.LMenuItem
import dev.lingvo.site.ds.LMenuPlacement
import dev.lingvo.site.ds.LPlusIcon
import dev.lingvo.site.ds.LProgressBar
import dev.lingvo.site.ds.LProgressCounts
import dev.lingvo.site.ds.LRefreshIcon
import dev.lingvo.site.ds.LSectionTitle
import dev.lingvo.site.ds.LSettingsIcon
import dev.lingvo.site.ds.LSkeleton
import dev.lingvo.site.ds.LSkeletonShape
import dev.lingvo.site.ds.LSparkleIcon
import dev.lingvo.site.ds.LStatTile
import dev.lingvo.site.ds.LTimeStyle
import dev.lingvo.site.ds.LToastVariant
import dev.lingvo.site.ds.LUploadIcon
import dev.lingvo.site.ds.LVisuallyHiddenStyle
import dev.lingvo.site.ds.LWandSparklesIcon
import dev.lingvo.site.ds.LWarningIcon
import dev.lingvo.site.ds.LocalToasts
import dev.lingvo.site.ds.IconSize
import dev.lingvo.site.ds.PageHeader
import dev.lingvo.site.ds.Radius
import dev.lingvo.site.ds.Space
import dev.lingvo.site.ds.TypeScale
import dev.lingvo.site.ds.displayFont
import dev.lingvo.site.ds.enterStaggered
import dev.lingvo.site.ds.formatCount
import dev.lingvo.site.ds.formatUtc
import dev.lingvo.site.ds.iconSize
import dev.lingvo.site.ds.monoFont
import dev.lingvo.site.ds.tabularNumbers
import dev.lingvo.site.ds.toSitePalette
import dev.lingvo.site.ds.transitionColors
import dev.lingvo.site.i18n.t
import dev.lingvo.site.i18n.tPlural
import dev.lingvo.site.i18n.tf
import dev.lingvo.site.i18n.tr
import dev.lingvo.site.i18n.trf
import dev.lingvo.site.nav.AppNav
import dev.lingvo.site.pages.app.projects.slug.settings.displayLabel
import dev.lingvo.site.state.ProjectDirectory
import dev.lingvo.site.state.WorkspaceActionClaim
import dev.lingvo.site.state.runWorkspaceAction
import dev.lingvo.site.state.WorkspacePrivilege
import dev.lingvo.site.state.WorkspaceRequestContext
import dev.lingvo.site.state.WorkspaceRequestKind
import kotlin.js.Date
import kotlin.math.roundToInt
import kotlinx.coroutines.CancellationException
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H2
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text
import dev.lingvo.site.components.ProjectIcon

/**
 * `auto-fit` rather than a fixed four, because the strip is not always four tiles wide and a
 * three-tile row in a four-column grid ends in a hole that reads as a tile that failed to load.
 */
val SummaryGridStyle = CssStyle.base {
    Modifier
        .fillMaxWidth()
        .gap(Space.MD)
        .styleModifier {
            property("display", "grid")
            property("grid-template-columns", "repeat(auto-fit, minmax(170px, 1fr))")
        }
}

val ProjectGridStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .gap(Space.LG)
            .styleModifier {
                property("display", "grid")
                property("grid-template-columns", "minmax(0, 1fr)")
            }
    }
    Breakpoint.MD {
        Modifier.styleModifier { property("grid-template-columns", "repeat(2, minmax(0, 1fr))") }
    }
    Breakpoint.XL {
        Modifier.styleModifier { property("grid-template-columns", "repeat(3, minmax(0, 1fr))") }
    }
}

@Page("/app")
@Layout(".components.layouts.AppLayout")
@Composable
fun DashboardPage() {
    val ctx = rememberPageContext()

    // The dashboard is a management surface. A translator who opens Lingvo wants the queue, and
    // landing them on numbers that are not their business is how "where do I start?" becomes a
    // support question. REPLACE so Back still leaves the app rather than bouncing here again.
    val workspaceContext = WorkspaceRequestContext.current()
    val role = workspaceContext?.role
    val landing = AppNav.landingFor(role)
    LaunchedEffect(landing) {
        if (landing != "/app") ctx.router.tryRoutingTo(landing, UpdateHistoryMode.REPLACE)
    }
    if (landing != "/app") return

    var refreshKey by remember { mutableStateOf(0) }
    // One call. The page used to fetch the project list and then fan out one activity request per
    // project **from the browser** — twelve projects on a scale-to-zero machine with a cold database
    // connection was a six-second first paint on the page that has to be fastest.
    val overviewDecision = workspaceContext?.decision(WorkspaceRequestKind.OVERVIEW)
    val reloadable = if (workspaceContext != null && overviewDecision?.allowed == true) {
        loadReloadable(workspaceContext.key, reloadToken = refreshKey) {
            ApiClient.overview(workspaceContext.workspace.slug).also { response ->
                check(workspaceContext.acceptsOverview(response)) {
                    "The server returned an overview for a different workspace."
                }
            }
        }
    } else {
        null
    }
    val state: Async<OverviewResponse> = when {
        workspaceContext == null -> Async.Success(
            OverviewResponse(
                verdict = t("app.index.join_or_create_a_workspace_to", "Join or create a workspace to begin."),
                hasWorkspace = false,
            ),
        )
        overviewDecision?.allowed != true -> Async.Failure(overviewDecision?.refusal.orEmpty())
        else -> requireNotNull(reloadable).state
    }
    val canManageProjects = workspaceContext?.canManageProjects == true
    // Kept apart, because they send the reader to two different people. A translator's answer is
    // their role; an admin in two workspaces on an older server has a role that is fine and a
    // request the server cannot place. Told as one sentence — "project creation is unavailable for
    // this workspace" — the first reader was sent to ask about a workspace that is not the problem.
    val canCreateProject = canManageProjects &&
        workspaceContext?.decision(WorkspaceRequestKind.CREATE_PROJECT)?.allowed == true

    Column(Modifier.fillMaxWidth().gap(Space.XXXL)) {
        PageHeader(
            title = t("app.index.overview", "Overview"),
            // The outstanding fact, from the server. The page used to open with "Welcome back,
            // Maya" — a greeting in the most valuable space on the screen.
            subtitle = (state as? Async.Success)?.value?.verdict,
        ) {
            // **The page most people leave open while they push.** Reloading the browser was the
            // only way to see what a `lingvo push` had just done. The initiating control is the
            // only thing that goes busy — `loadReloadable` holds the last good page underneath it.
            if (reloadable != null) {
                LIconAction(
                    label = t("app.index.refresh_this_overview", "Refresh this overview"),
                    onClick = { refreshKey++ },
                    loading = reloadable.refreshing,
                    enabled = !reloadable.refreshing,
                ) { LRefreshIcon() }
            }
            if (canCreateProject) {
                DashboardCreateProjectAction { ctx.router.tryRoutingTo("/app/projects/new") }
            }
        }
        reloadable?.refreshError?.let { failure ->
            // The outcome of a refresh the reader asked for. `LAlert`'s own contract reserves
            // `live` for exactly this, and without it the failure is only available to someone
            // who happens to look at the top of the page again.
            LAlert(
                t("app.index.the_refresh_did_not_replace_this", "The refresh did not replace this workspace"),
                failure.message,
                variant = LAlertVariant.WARNING,
                live = true,
            )
        }
        when (state) {
            Async.Loading -> OverviewSkeleton()
            is Async.Failure -> if (overviewDecision?.allowed == false) {
                LAlert(
                    t("app.index.this_workspace_needs_a_newer_server", "This workspace needs a newer server"),
                    state.message,
                    variant = LAlertVariant.INFO,
                )
            } else {
                AsyncFailureState(state, onRetry = { refreshKey++ })
            }
            is Async.Success -> DashboardContent(
                data = state.value,
                workspaceContext = workspaceContext,
                canCreateProject = canCreateProject,
                canManageProjects = canManageProjects,
                onReload = { refreshKey++ },
                onNewProject = {
                    if (canCreateProject) ctx.router.tryRoutingTo("/app/projects/new")
                },
                onNavigate = { path -> ctx.router.tryRoutingTo(path) },
            )
        }
    }
}

/**
 * The page's own shape, in grey, rather than six identical bars.
 *
 * A generic skeleton stack is only marginally better than a spinner: it still moves everything when
 * the real content lands, which on the most-visited page in the product is the jump people learn to
 * wait for. This draws the sections that are actually coming — a verdict card, the summary strip,
 * two readiness cards, the log — so the layout is settled before the response is.
 *
 * **One live region, not sixteen.** [LSkeleton] announces itself as a `status`, which is right for
 * one bar and unbearable for a page of them, so the bars are hidden from assistive technology and a
 * single sentence speaks for all of them.
 */
@Composable
private fun OverviewSkeleton() {
    Span(LVisuallyHiddenStyle.toModifier().attr("role", "status").toAttrs()) {
        Text(t("app.index.loading_your_overview", "Loading your overview."))
    }
    Column(
        Modifier.fillMaxWidth().gap(Space.XXL).attr("aria-hidden", "true"),
    ) {
        LCard(Modifier.fillMaxWidth()) {
            LSkeleton(width = 60.percent, height = 15.px, shape = LSkeletonShape.TEXT)
        }
        Column(Modifier.fillMaxWidth().gap(Space.MD)) {
            LSkeleton(width = 180.px, height = 21.px, shape = LSkeletonShape.TEXT)
            Div(SummaryGridStyle.toModifier().toAttrs()) {
                repeat(4) {
                    LCard(Modifier.fillMaxWidth()) {
                        LSkeleton(height = 64.px)
                    }
                }
            }
            repeat(2) {
                LCard(Modifier.fillMaxWidth()) {
                    Column(Modifier.fillMaxWidth().gap(Space.SM)) {
                        LSkeleton(width = 220.px, height = 17.px, shape = LSkeletonShape.TEXT)
                        LSkeleton(width = 90.percent, height = 15.px, shape = LSkeletonShape.TEXT)
                        LSkeleton(width = 70.percent, height = 15.px, shape = LSkeletonShape.TEXT)
                    }
                }
            }
        }
        Column(Modifier.fillMaxWidth().gap(Space.MD)) {
            LSkeleton(width = 150.px, height = 21.px, shape = LSkeletonShape.TEXT)
            LCard(Modifier.fillMaxWidth()) {
                Column(Modifier.fillMaxWidth().gap(Space.LG)) {
                    repeat(3) {
                        LSkeleton(width = 80.percent, height = 15.px, shape = LSkeletonShape.TEXT)
                    }
                }
            }
        }
    }
}

/**
 * The header's standing door to a new project.
 *
 * Its own composable because the dashboard's accent budget is decided across the header *and* the
 * sections below it, and a rule that lives inside one `PageHeader` lambda cannot be read — or
 * tested — beside the control it is competing with.
 */
@Composable
internal fun DashboardCreateProjectAction(onNewProject: () -> Unit) {
    // **Secondary, because this page's one accent is already spoken for.** The attention section
    // gives it to its first item and argues for that in its own comment; a variant-less button up
    // here quietly made that two, and a workspace with no projects — whose readiness section draws
    // a second "New project" — made it three identical accent claims on one screen.
    LButton(
        label = t("app.index.new_project", "New project"),
        onClick = onNewProject,
        variant = LButtonVariant.SECONDARY,
        leadingIcon = { LPlusIcon() },
    )
}

@Composable
internal fun DashboardContent(
    data: OverviewResponse,
    workspaceContext: WorkspaceRequestContext?,
    canCreateProject: Boolean,
    canManageProjects: Boolean,
    onReload: () -> Unit,
    onNewProject: () -> Unit,
    onNavigate: (String) -> Unit,
) {
    val scope = rememberCoroutineScope()
    val toasts = LocalToasts.current
    // Hidden locally the moment it is clicked. The server records it too, but waiting a round trip
    // to make a dismissed thing disappear is what makes a dismissal feel like it did not work.
    var dismissed by remember(workspaceContext?.key) { mutableStateOf(emptySet<String>()) }
    // A refused capability is not a failed request. The local hide ran either way, so on an older
    // server the item vanished, came back on the next load, and nothing had said it would.
    val canDismissAttention =
        workspaceContext?.decision(WorkspaceRequestKind.DISMISS_ATTENTION)?.allowed == true

    // The captured claim a failed run is retried under.
    //
    // The retry route is `MT_SPEND`, owner-or-admin, and the privilege resolves to exactly
    // `role.atLeast(ADMIN)` on exactly this workspace — so the control is absent for precisely the
    // people the server would refuse, and fails closed the same way if the role changes mid-flight.
    val spendClaim = WorkspaceActionClaim.capture(workspaceContext, WorkspacePrivilege.MT_SPEND)
    // The item whose run is being priced. One at a time, because the confirm is a modal.
    var retryTarget by remember(workspaceContext?.key) { mutableStateOf<AttentionItemDto?>(null) }

    // **No entrance on this root, and the reasoning that put one here was wrong.** The failure arm
    // of the `when` above rises, so the success arm looked bare by comparison and I gave it a rise
    // to match. But this column's own children include an `LEmptyState` — for a reader with no
    // workspace — and that component applies `enterRise` itself, so the matching produced the
    // nested double entrance this codebase rejects one file over, in `LAsyncContent`, for exactly
    // the same reason. The asymmetry between the arms is not a defect: the failure arm rises
    // *because its content does*, and so does this one whenever it has content that rises.
    Column(Modifier.fillMaxWidth().gap(Space.XXL)) {
        // No workspace is not the same as an empty one, and it needs a different answer. Before
        // `hasWorkspace` existed both looked identical here — no projects, no work log — so this
        // person was shown the first-run screen and offered a sample project that would be seeded
        // into a workspace they do not have. It failed when pressed.
        if (!data.hasWorkspace) {
            LEmptyState(
                title = t("app.index.you_are_not_in_a_workspace", "You are not in a workspace yet"),
                description = t("app.index.a_workspace_holds_your_projects_your", "A workspace holds your projects, your team and your billing. " +
                    "Create one, or ask whoever invited you to send the invitation again."),
                action = {
                    LButton(
                        label = t("app.index.create_a_workspace", "Create a workspace"),
                        onClick = { onNavigate("/app/workspaces") },
                        variant = LButtonVariant.PRIMARY,
                    )
                },
            )
            return@Column
        }

        if (data.isFirstRun) {
            FirstRun(
                canManageProjects = canManageProjects,
                workspaceContext = workspaceContext,
                createAllowed = canCreateProject,
                onNewProject = onNewProject,
                onOpenProject = { slug -> onNavigate("/app/projects/$slug") },
                onNavigate = onNavigate,
            )
            return@Column
        }

        AttentionSection(
            data = data,
            dismissed = dismissed,
            dismissAllowed = canDismissAttention,
            onDismiss = { key ->
                dismissed = dismissed + key
                scope.launch {
                    // A dismissal that fails is not worth interrupting anybody over: the item comes
                    // back on the next load, which is the honest outcome. Ignoring a *failure* is
                    // not the same as ignoring cancellation, though — `runCatching` swallowed the
                    // CancellationException of leaving the page along with it.
                    workspaceContext?.let { context ->
                        if (context.decision(WorkspaceRequestKind.DISMISS_ATTENTION).allowed) {
                            try {
                                ApiClient.dismissAttention(context.workspace.slug, key)
                            } catch (cancelled: CancellationException) {
                                throw cancelled
                            } catch (_: Throwable) {
                                // Deliberately silent; see above.
                            }
                        }
                    }
                }
            },
            // **"Show them again" used to be a local lie.** It cleared this page's own set and the
            // server went on hiding the same items for a week, so the next load put them straight
            // back. The undismiss route exists now, and this is the only caller of it.
            onRestore = {
                val keys = dismissed
                dismissed = emptySet()
                scope.launch {
                    workspaceContext?.let { context ->
                        keys.forEach { key ->
                            try {
                                ApiClient.restoreAttention(context.workspace.slug, key)
                            } catch (cancelled: CancellationException) {
                                throw cancelled
                            } catch (_: Throwable) {
                                // The item is already back on screen; the next load reconciles.
                            }
                        }
                    }
                    onReload()
                }
            },
            // Absent, not disabled, when this role cannot spend: the card falls back to following
            // its own `actionHref`, which is a read-only receipt anybody may open. Pressing it
            // opens the price, never the spend — the confirm below is what starts a run.
            onRetry = spendClaim?.let { { item: AttentionItemDto -> retryTarget = item } },
            onReload = onReload,
            onNavigate = onNavigate,
        )
        ReadinessSection(data = data, onNewProject = onNewProject, onReload = onReload, onNavigate = onNavigate)
        CreditsSection(data = data, onNewProject = onNewProject, onReload = onReload, onNavigate = onNavigate)
        RecentWorkSection(data = data, onReload = onReload, onNavigate = onNavigate)

        // **Estimate before, receipt after — the same confirm every other pre-translate door in
        // the product uses.** "Try again" used to call `POST /mt/jobs/{id}/retry` straight from the
        // card, and that route reserves credits inside `prepareMtJob`: one press committed the
        // money and the receipt toast afterwards was the first mention of a price. Spec §2.5
        // forbids a machine action that spends without a server-computed estimate in the confirm,
        // and §5 says these cards run that confirm in place — so the card names the run and this
        // dialog prices exactly the request it will post.
        //
        // The scope is the failed run's own provider and languages, which the item already carries;
        // `onlyEmpty` stays at its default, which is what is actually left after a run that failed
        // part-way. Mounted only while an item is chosen, so opening the page prices nothing.
        retryTarget?.let { item ->
            val slug = item.projectSlug
            val locales = item.locales.ifEmpty { listOfNotNull(item.locale) }
            if (slug != null && locales.isNotEmpty()) {
                PretranslateConfirm(
                    open = true,
                    slug = slug,
                    locales = locales,
                    scope = PretranslateScope(provider = item.provider),
                    onStarted = { startedJobId ->
                        // The receipt door, held open until it is closed: a run whose id is never
                        // shown and whose toast expires is a charge with nothing to look up.
                        toasts.showWithAction(
                            message = tr(
                                "app.index.the_run_started_again",
                                "The run started again.",
                            ),
                            actionLabel = tr("app.index.open_receipt", "Open receipt"),
                            onAction = { onNavigate(jobReceiptHref(slug, startedJobId)) },
                            variant = LToastVariant.SUCCESS,
                        )
                        retryTarget = null
                        onReload()
                    },
                    onClose = { retryTarget = null },
                )
            }
        }
    }
}

/**
 * One section, title bound to its own content.
 *
 * The gap inside a section is [Space.MD] and the gap between sections is [Space.XXL], so a heading
 * belongs to the thing under it by proximity rather than by the reader's goodwill. Every section
 * renders its title in all three of its states — populated, empty and failed — because a heading
 * that disappears when its block is empty makes the page a different shape on a new workspace than
 * it is on a busy one, and nobody learns where anything lives.
 */
@Composable
private fun Section(
    title: String,
    /**
     * The section's mark, aria-hidden inside the `H2`.
     *
     * Four sections that all open with the same weight of bare text are four identical shapes to
     * scan past; the glyph is what makes "Credits" findable without reading it.
     */
    icon: @Composable () -> Unit,
    content: @Composable () -> Unit,
) {
    Column(Modifier.fillMaxWidth().gap(Space.MD)) {
        SectionTitle(title, icon)
        content()
    }
}

/**
 * Three empties, three different sentences.
 *
 * "Nothing needs your attention" and "you put the last one away thirty seconds ago" are not the same
 * state and must not read as the same state: the first is the product telling you it checked, the
 * second is you having hidden the answer, and printing the first when the second is true sends
 * somebody looking for a bug that is not there.
 */
@Composable
private fun AttentionSection(
    data: OverviewResponse,
    dismissed: Set<String>,
    /** Whether this server will record a dismissal at all; when it will not, none is offered. */
    dismissAllowed: Boolean,
    onDismiss: (String) -> Unit,
    onRestore: () -> Unit,
    /** Null when this role may not spend credits; the card then falls back to its href. */
    onRetry: ((AttentionItemDto) -> Unit)?,
    onReload: () -> Unit,
    onNavigate: (String) -> Unit,
) {
    val visible = data.attention.filterNot { it.key in dismissed }
    val hidden = data.attention.count { it.key in dismissed }
    // The project furthest from shipping, which the server has already sorted to the front.
    val worst = data.projects.firstOrNull { !it.shippable }

    Section(t("app.index.needs_your_attention", "Needs your attention"), { LCircleAlertIcon() }) {
        when {
            "attention" in data.failed -> BlockFailure(t("app.index.what_needs_attention", "what needs attention"), onReload)
            visible.isNotEmpty() -> Column(Modifier.fillMaxWidth().gap(Space.MD)) {
                visible.forEachIndexed { index, item ->
                    AttentionCard(
                        item = item,
                        // Accent goes to the first item only. The list is already ordered worst
                        // first, and four accent-filled buttons are four equal claims on the eye —
                        // the same argument this file makes three sections down for why only QA
                        // errors takes accent among the summary tiles.
                        emphasized = index == 0,
                        dismissible = item.dismissible && dismissAllowed,
                        // **A failed run is priced and restarted here, not two navigations away.**
                        // The item already carries the provider and the languages it ran on, so
                        // following `actionHref` to the receipt only to press the same verb again
                        // was a detour through a page nobody wanted to read. What the press opens
                        // is the estimate confirm, never the spend.
                        onAct = if (
                            item.kind == AttentionKind.RETRY_PRETRANSLATE &&
                            item.projectSlug != null &&
                            (item.locales.isNotEmpty() || item.locale != null) &&
                            onRetry != null
                        ) {
                            { onRetry(item) }
                        } else {
                            { onNavigate(item.actionHref) }
                        },
                        onDismiss = { onDismiss(item.key) },
                    )
                }
            }
            // Empty because you put them away, said plainly — and now genuinely undone rather than
            // hidden a second time. The dismissal is recorded for a week server-side, and the
            // DELETE route this button calls is what actually cancels it; before that route
            // existed this cleared a local set and the next load put every item straight back.
            hidden > 0 -> SectionNote(
                headline = tf(
                    "app.index.you_put_count_away",
                    "You put {count} away.",
                    "count" to countLabel(hidden, "item"),
                ),
                detail = t("app.index.nothing_else_needs_you_dismissed_items_2", "Nothing else needs you. Dismissed items stay hidden for a week unless " +
                    "you bring them back, and come back sooner if the situation changes."),
            ) {
                LButton(
                    label = t("app.index.show_them_again", "Show them again"),
                    onClick = onRestore,
                    variant = LButtonVariant.SECONDARY,
                    size = LButtonSize.SM,
                    leadingIcon = { LArchiveRestoreIcon() },
                )
            }
            // Empty because there is genuinely nothing: the verdict says what is true instead.
            else -> SectionNote(
                headline = t("app.index.nothing_needs_your_attention", "Nothing needs your attention."),
                detail = data.verdict,
            ) {
                if (worst != null) {
                    LButton(
                        label = tf("app.index.open_name", "Open {name}", "name" to worst.name),
                        onClick = { onNavigate(worst.href) },
                        variant = LButtonVariant.SECONDARY,
                        size = LButtonSize.SM,
                    )
                } else {
                    LButton(
                        label = t("app.index.see_all_activity", "See all activity"),
                        onClick = { onNavigate("/app/activity") },
                        variant = LButtonVariant.SECONDARY,
                        size = LButtonSize.SM,
                    )
                }
            }
        }
    }
}

/**
 * A quiet empty, for the state a healthy workspace is in most days.
 *
 * Deliberately not [LEmptyState]: that primitive is 48px of padding and a glyph mosaic, which is
 * right once on a page and wallpaper three times. "Nothing needs you" is the *normal* answer here,
 * and the normal answer should not be the loudest thing on the screen.
 */
@Composable
private fun SectionNote(
    headline: String,
    detail: String,
    action: @Composable () -> Unit,
) {
    val palette = ColorMode.current.toSitePalette()
    LCard(Modifier.fillMaxWidth()) {
        Row(
            Modifier.fillMaxWidth().gap(Space.MD).flexWrap(FlexWrap.Wrap),
            verticalAlignment = Alignment.CenterVertically,
        ) {
            Column(Modifier.flexGrow(1).styleModifier { property("flex-basis", "240px") }.minWidth(0.px).gap(Space.XS)) {
                Span(Modifier.fontWeight(600).toAttrs()) { Text(headline) }
                Span(
                    Modifier
                        .color(palette.textSecondary)
                        .fontSize(TypeScale.BodySmall)
                        .lineHeight(TypeScale.BodyLineHeight)
                        .toAttrs(),
                ) { Text(detail) }
            }
            action()
        }
    }
}

/**
 * How far the whole workspace is from a release, and where each project stands.
 *
 * The empty here is not the first-run empty: a workspace with a work log and no projects has had
 * projects, so it gets a different sentence and the same single action.
 */
@Composable
private fun ReadinessSection(
    data: OverviewResponse,
    onNewProject: () -> Unit,
    onReload: () -> Unit,
    onNavigate: (String) -> Unit,
) {
    Section(t("app.index.release_readiness", "Release readiness"), { LListChecksIcon() }) {
        when {
            "readiness" in data.failed -> BlockFailure(t("app.index.release_readiness_2", "release readiness"), onReload)
            data.projects.isEmpty() -> LEmptyState(
                title = t("app.index.nothing_to_measure_yet", "Nothing to measure yet"),
                description = t("app.index.readiness_counts_what_stands_between_each", "Readiness counts what stands between each language and a release — " +
                    "strings not translated, translations not reviewed, and QA errors. It needs a " +
                    "project to count them in."),
                modifier = Modifier.fillMaxWidth(),
                icon = LEmptyStateIcon.SUCCESS,
            ) {
                // Secondary: an empty state invites one action, and on this page the accent is the
                // top attention card's. Two accent-filled "New project" buttons — this one and the
                // header's — are one invitation drawn twice.
                LButton(
                    t("app.index.new_project", "New project"),
                    onNewProject,
                    variant = LButtonVariant.SECONDARY,
                    leadingIcon = { LPlusIcon() },
                )
            }
            else -> Column(Modifier.fillMaxWidth().gap(Space.MD)) {
                WorkRemaining(data.projects)
                data.projects.forEach { project ->
                    ReadinessSummaryCard(project, onNavigate)
                }
                Row(Modifier.fillMaxWidth().gap(Space.SM)) {
                    LButton(
                        label = t("app.index.see_all_projects", "See all projects"),
                        onClick = { onNavigate("/app/projects") },
                        variant = LButtonVariant.GHOST,
                        size = LButtonSize.SM,
                    )
                }
            }
        }
    }
}

/**
 * The four counters added up, and the one line the page cannot otherwise say.
 *
 * Every number here is a sum of what `/overview` returned, never a figure of its own: the sentence
 * under the strip names the scope so nobody reads it as a workspace total when the server has
 * capped the project list. Skipped entirely when everything is zero — four zeroes is not a summary,
 * and the readiness cards below already say "release-ready" in words.
 *
 * **The per-tile captions live in that sentence now, and only two of the four survived.** Each tile
 * used to carry a line of its own — "no value at all", "translated, but failing a check" — and
 * [LStatTile] has no slot for one: its `delta` is a trend and draws a direction glyph beside the
 * text, which would put an arrow next to a definition. Two of the captions were restating their own
 * label ("Untranslated" is untranslated), so they are gone rather than moved. The two that carried
 * something the label does not — what "QA errors" counts, and what "Machine" means — are said
 * once underneath, which is one sentence to read instead of four labels to double-check.
 */
@Composable
internal fun WorkRemaining(projects: List<OverviewProjectDto>) {
    val locales = projects.flatMap { it.locales }
    if (locales.isEmpty()) return
    val untranslated = locales.sumOf { it.untranslated }
    val awaitingReview = locales.sumOf { it.awaitingReview }
    val qaErrors = locales.sumOf { it.qaErrors }
    val machine = locales.sumOf { it.machineUnreviewed }
    val blocked = locales.sumOf { it.blocked }
    if (untranslated + awaitingReview + qaErrors + machine + blocked == 0) return

    val palette = ColorMode.current.toSitePalette()
    Column(Modifier.fillMaxWidth().gap(Space.SM)) {
        // **Every tile is a destination now.** These were the four loudest numbers on the page and
        // three of them went nowhere, so reading "412 untranslated" and then finding those 412 was
        // a hunt through the project list. `/app/work` is the queue that holds both of the first
        // two, filtered by the server, which is the same rule `ReadinessCount` keeps: a number
        // links only where the destination is the set it counts.
        Div(SummaryGridStyle.toModifier().toAttrs()) {
            LStatTile(
                label = t("app.index.untranslated", "Untranslated"),
                value = formatCount(untranslated),
                icon = { LLanguagesIcon() },
                href = "/app/work",
            )
            LStatTile(
                label = t("app.index.awaiting_review", "Awaiting review"),
                value = formatCount(awaitingReview),
                icon = { LListChecksIcon() },
                href = "/app/work",
            )
            // The only counter that can fail a release outright, so the only one that takes accent —
            // and the only one worth a filtered destination, when a single project owns every one
            // of them.
            LStatTile(
                label = t("app.index.qa_errors", "QA errors"),
                value = formatCount(qaErrors),
                icon = { LCircleAlertIcon() },
                tone = LBadgeVariant.DANGER,
                emphasis = qaErrors > 0,
                href = projects
                    .filter { project -> project.locales.sumOf { it.qaErrors } > 0 }
                    .singleOrNull()
                    ?.let { "/app/projects/${it.slug}/qa" },
            )
            LStatTile(
                label = t("app.index.machine", "Machine"),
                value = formatCount(machine),
                icon = { LBotIcon() },
            )
        }
        Span(
            Modifier.color(palette.textSecondary).fontSize(TypeScale.Small).toAttrs(),
        ) {
            // The frame was English and so was its subject-verb agreement — `if (blocked == 1)
            // "is" else "are"` is the same rule `countLabel` exists to stop applying to every
            // language. The counted clause is one plural key; the frame is one sentence.
            Text(
                tf(
                    "app.index.across_projects_and_languages_below",
                    "Across {projects} and {languages} below.",
                    "projects" to countLabel(projects.size, "project"),
                    "languages" to countLabel(locales.size, "language"),
                ) +
                    " " +
                    t(
                        "app.index.qa_errors_are_translated_strings_failing",
                        "QA errors are translated strings failing a check; machine counts what a " +
                            "provider wrote and nobody has read.",
                    ) +
                    if (blocked > 0) {
                        " " + tPlural(
                            "app.index.count.blocked_string",
                            blocked,
                            "{count} string is waiting on an answer.",
                            "{count} strings are waiting on an answer.",
                        )
                    } else {
                        ""
                    },
            )
        }
    }
}

/**
 * One thing to do, one sentence, one verb.
 *
 * Never a widget. An attention item that renders a chart is a report row that has talked its way
 * into the only part of the page people reliably read.
 *
 * Severity is a badge with a word in it, not a coloured rule down the leading edge: an edge bar is
 * banned system-wide, and it carried the severity in colour alone — which said nothing to anybody
 * reading in greyscale or with a screen reader.
 */
@Composable
private fun AttentionCard(
    item: AttentionItemDto,
    /** Whether this card's action carries the page's single accent; the first one does. */
    emphasized: Boolean,
    /** The item allows it *and* this server records it. Offered on neither half alone. */
    dismissible: Boolean,
    onAct: () -> Unit,
    onDismiss: () -> Unit,
) {
    val (severityLabel, severityVariant) = when (item.severity) {
        AttentionSeverity.DANGER -> t("app.index.urgent", "Urgent") to LBadgeVariant.DANGER
        AttentionSeverity.WARNING -> t("app.index.soon", "Soon") to LBadgeVariant.WARNING
        AttentionSeverity.INFO -> t("app.index.note", "Note") to LBadgeVariant.INFO
    }
    LCard(Modifier.fillMaxWidth()) {
        Row(
            Modifier.fillMaxWidth().gap(Space.MD).flexWrap(FlexWrap.Wrap),
            verticalAlignment = Alignment.CenterVertically,
        ) {
            // **The badge leads the sentence it qualifies rather than sitting between it and the
            // buttons.** Drawn last, it landed immediately left of two SM buttons at the same size
            // and baseline, so the row scanned as "Note | Answer | Not now" — a pill that looks
            // like a control and does nothing. Identity, then state, then task.
            LBadge(severityLabel, variant = severityVariant)
            Span(
                Modifier
                    .flexGrow(1)
                    .styleModifier { property("flex-basis", "240px") }.minWidth(0.px)
                    .fontSize(TypeScale.BodySmall)
                    .lineHeight(TypeScale.BodyLineHeight)
                    .toAttrs(),
            ) { Text(item.message) }
            LButton(
                label = item.actionLabel,
                onClick = onAct,
                variant = if (emphasized) LButtonVariant.PRIMARY else LButtonVariant.SECONDARY,
                size = LButtonSize.SM,
                leadingIcon = if (item.kind == AttentionKind.RETRY_PRETRANSLATE) {
                    { LWandSparklesIcon() }
                } else {
                    null
                },
                // The server sends one of these per failed pre-translate run, up to five, every one
                // of them labelled "Try again" and pointing somewhere different. The sentence that
                // tells them apart is the sibling span, which is not part of any of their names.
                accessibleLabel = trf(
                    "app.index.action_label_message",
                    "{action}: {message}",
                    "action" to item.actionLabel,
                    "message" to item.message,
                ),
            )
            if (dismissible) {
                LButton(
                    label = t("app.index.not_now", "Not now"),
                    onClick = onDismiss,
                    variant = LButtonVariant.GHOST,
                    size = LButtonSize.SM,
                    accessibleLabel = tf("app.index.dismiss_message", "Dismiss: {message}", "message" to item.message),
                )
            }
        }
    }
}

/**
 * What one project card knows about the work left in it, so the menu beside it can state counts.
 *
 * A value type rather than two overloads: the dashboard reads `OverviewProjectDto` and the projects
 * page reads `ProjectSummaryDto`, and the *menu* must not be written twice — that is how the two
 * surfaces end up offering different verbs for the same project.
 */
internal data class ProjectMenuFacts(
    val slug: String,
    val name: String,
    /** The language furthest from shippable, which the server has already sorted to the front. */
    val worstLocale: String?,
    val untranslated: Int = 0,
    val awaitingReview: Int = 0,
    val qaErrors: Int = 0,
)

/**
 * Everything else this project card can do, behind one ellipsis.
 *
 * **Counts, never "all".** An entry appears only when its number is real and greater than zero, so
 * nothing here promises work that does not exist — a menu that always offers "Fix the first QA
 * error" on a clean project is a menu people stop opening.
 *
 * **The run is priced here, on the card.** It used to be a deep link into `/pretranslate`, because
 * this page holds a *workspace* claim and a project spend has to be gated on a verified project
 * authority — which only exists while the browser is on a project route. [PretranslateConfirm] now
 * resolves that for itself: the verified project route when there is one, and the selected
 * workspace's own `MT_SPEND` bar when there is not. Both are owner-or-admin, which is the bar the
 * spend route applies, so the estimate and the receipt can happen where the count is read rather
 * than two navigations away on a page whose only job was to hold the same number again.
 *
 * The deep link survives as the entry underneath it. "Pre-translate French" runs the language this
 * card is worst at; **"Choose scope…"** is for the run this menu cannot describe — a tag, one file,
 * a different tone — and that form lives on `/pretranslate` and always will.
 *
 * The count travels in the first entry's description, where it is a fact about the language rather
 * than a promise about what the estimate will say: the card's number is a snapshot of the last
 * `/overview`, and the dialog's is the server's arithmetic at the moment somebody asks for a price.
 */
@Composable
internal fun ProjectActionMenu(facts: ProjectMenuFacts, onNavigate: (String) -> Unit) {
    var expanded by remember(facts.slug) { mutableStateOf(false) }
    // The dialog is mounted by this menu but is not part of it: closing the menu on select must not
    // take the confirm down with it, so the flag lives beside `expanded` rather than inside it.
    var confirming by remember(facts.slug) { mutableStateOf(false) }
    val locale = facts.worstLocale
    val language = locale?.let { localeInfo(it).englishName }
    // The shell's host, not `LocalToasts`: this menu also renders on `/app/projects`, and reading a
    // composition local that a card cannot guarantee is provided turns a missing provider into a
    // blank page. Absent, the run still starts — it simply reports itself on the page it opens.
    val toasts = ShellToastHost.state

    val entries = buildList<Pair<LMenuEntry, () -> Unit>> {
        if (locale != null && language != null) {
            if (facts.untranslated > 0) {
                add(
                    LMenuItem(
                        label = tf(
                            "app.index.pre_translate_language",
                            "Pre-translate {language}",
                            "language" to language,
                        ),
                        icon = { LWandSparklesIcon() },
                        description = tPlural(
                            "app.index.count.untranslated_string",
                            facts.untranslated,
                            "{count} untranslated string",
                            "{count} untranslated strings",
                        ),
                    ) to { confirming = true },
                )
                add(
                    LMenuItem(
                        // The scope form, named for what it is rather than for where it lives. A
                        // second "Pre-translate…" beside the first is two entries the reader has to
                        // tell apart by their punctuation.
                        label = t("app.index.choose_scope", "Choose scope\u2026"),
                        icon = { LFilterIcon() },
                        description = t(
                            "app.index.a_tag_one_file_or_another",
                            "A tag, one file, or another language",
                        ),
                    ) to { onNavigate("/app/projects/${facts.slug}/pretranslate?locale=$locale") },
                )
            }
            if (facts.qaErrors > 0) {
                add(
                    LMenuItem(
                        label = t("app.index.fix_the_first_qa_error", "Fix the first QA error"),
                        icon = { LCircleAlertIcon() },
                        description = tPlural(
                            "app.index.count.string_with_errors",
                            facts.qaErrors,
                            "{count} string with errors",
                            "{count} strings with errors",
                        ),
                    ) to { onNavigate("/app/projects/${facts.slug}/qa?locale=$locale") },
                )
            }
            if (facts.awaitingReview > 0) {
                add(
                    LMenuItem(
                        label = tPlural(
                            "app.index.count.review_awaiting",
                            facts.awaitingReview,
                            "Review {count} awaiting",
                            "Review {count} awaiting",
                        ),
                        icon = { LListChecksIcon() },
                        description = language,
                    ) to { onNavigate("/app/projects/${facts.slug}/review/$locale") },
                )
            }
        }
        add(
            LMenuItem(
                label = t("app.index.import_strings", "Import strings"),
                icon = { LUploadIcon() },
            ) to { onNavigate("/app/projects/${facts.slug}/data") },
        )
        add(
            LMenuItem(
                label = t("app.index.project_settings", "Project settings"),
                icon = { LSettingsIcon() },
            ) to { onNavigate("/app/projects/${facts.slug}/settings") },
        )
    }

    LMenu(
        expanded = expanded,
        entries = entries.map { it.first },
        onExpandedChange = { expanded = it },
        onSelect = { index -> entries[index].second() },
        placement = LMenuPlacement.BOTTOM_END,
    ) { toggle, triggerModifier ->
        // One of these per card, so the name has to carry the project. "More actions" five times
        // over is five identical choices in a list of links.
        LIconAction(
            label = tf(
                "app.index.more_ways_to_work_on_name",
                "More ways to work on {name}",
                "name" to facts.name,
            ),
            onClick = toggle,
            modifier = triggerModifier,
            size = LButtonSize.SM,
        ) { LEllipsisIcon() }
    }

    // Estimate before, receipt after — both on this card. The dialog mounts nothing until
    // `confirming`, so opening a menu prices nothing; it resolves the authority it can actually
    // verify and refuses honestly when the answer is no.
    PretranslateConfirm(
        open = confirming && locale != null,
        slug = facts.slug,
        locales = listOfNotNull(locale),
        onStarted = { jobId ->
            // The receipt door, held open until it is closed: a run whose id is never shown and
            // whose toast expires is a charge with nothing to look up.
            toasts?.showWithAction(
                message = tr("app.index.pre_translation_started", "Pre-translation started."),
                actionLabel = tr("app.index.open_receipt", "Open receipt"),
                onAction = { onNavigate(jobReceiptHref(facts.slug, jobId)) },
                variant = LToastVariant.INFO,
            )
        },
        onClose = { confirming = false },
    )
}

/**
 * One project's distance from shippable, worst language first.
 *
 * **Only what is in the way is drawn.** The card used to print all five counters for every language
 * whether or not they were zero, so a finished German took the same five columns as a broken French
 * and a release-ready project was a block of thirty zeroes. Now a settled language says so in three
 * words and the numbers that remain are all real work.
 */
@Composable
private fun ReadinessSummaryCard(project: OverviewProjectDto, onNavigate: (String) -> Unit) {
    val palette = ColorMode.current.toSitePalette()
    val identity = ProjectDirectory.find(project.slug)
    LCard(Modifier.fillMaxWidth()) {
        Column(Modifier.fillMaxWidth().gap(Space.SM)) {
            Row(
                Modifier.fillMaxWidth().gap(Space.SM),
                verticalAlignment = Alignment.CenterVertically,
            ) {
                ProjectIcon(
                    slug = project.slug,
                    name = project.name,
                    iconKey = identity?.iconKey ?: ProjectIconKey.MONOGRAM,
                    accentKey = identity?.accentKey ?: ProjectAccentKey.INK,
                    hasCustomIcon = identity?.hasCustomIcon ?: false,
                )
                Span(Modifier.flexGrow(1).fontWeight(600).toAttrs()) { Text(project.name) }
                // **A project with target languages always states where it stands.** It used to say
                // "Release-ready" and nothing else when it wasn't — four languages with real work
                // left had no status here at all, only the per-language rows below to add it up from.
                if (project.locales.isNotEmpty()) {
                    if (project.shippable) {
                        LBadge(t("app.index.release_ready", "Release-ready"), variant = LBadgeVariant.SUCCESS)
                    } else {
                        val behind = project.locales.count { !it.shippable }
                        LBadge(
                            tPlural(
                                "app.index.count.languages_behind",
                                behind,
                                "{count} language behind",
                                "{count} languages behind",
                            ),
                            variant = LBadgeVariant.WARNING,
                        )
                    }
                }
                LButton(
                    label = t("app.index.open", "Open"),
                    onClick = { onNavigate(project.href) },
                    variant = LButtonVariant.GHOST,
                    size = LButtonSize.SM,
                    accessibleLabel = tf("app.index.open_name", "Open {name}", "name" to project.name),
                )
                // The worst language is the first one the server sent, and it is the one every
                // automation in this menu is scoped to. A release-ready project has none, and the
                // menu correctly falls back to the two entries that are always true.
                val worst = project.locales.firstOrNull { !it.shippable }
                ProjectActionMenu(
                    facts = ProjectMenuFacts(
                        slug = project.slug,
                        name = project.name,
                        worstLocale = worst?.locale,
                        untranslated = worst?.untranslated ?: 0,
                        awaitingReview = worst?.awaitingReview ?: 0,
                        qaErrors = worst?.qaErrors ?: 0,
                    ),
                    onNavigate = onNavigate,
                )
            }
            if (project.locales.isEmpty()) {
                // A project with no target language is not release-ready and not broken: there is
                // simply nothing to measure. The one action is the one that starts the measuring.
                Row(
                    Modifier.fillMaxWidth().gap(Space.MD).flexWrap(FlexWrap.Wrap),
                    verticalAlignment = Alignment.CenterVertically,
                ) {
                    Span(
                        Modifier
                            .flexGrow(1)
                            .styleModifier { property("flex-basis", "240px") }.minWidth(0.px)
                            .color(palette.textSecondary)
                            .fontSize(TypeScale.BodySmall)
                            .toAttrs(),
                    ) {
                        Text(t("app.index.no_target_language_yet_so_there", "No target language yet, so there is nothing to be ready for."))
                    }
                    LButton(
                        label = t("app.index.add_a_language", "Add a language"),
                        onClick = { onNavigate("/app/projects/${project.slug}/settings?tab=languages") },
                        variant = LButtonVariant.SECONDARY,
                        size = LButtonSize.SM,
                        accessibleLabel = tf(
                            "app.index.add_a_language_to_name",
                            "Add a language to {name}",
                            "name" to project.name,
                        ),
                    )
                }
            }
            project.locales.forEach { locale ->
                ReadinessLocaleRow(project.slug, locale)
            }
        }
    }
}

/**
 * One language, as a scannable row: name, a measure of progress, then only the counters that are
 * not zero.
 *
 * **A CSS grid, not a wrapping flex row.** Four languages used to be four independent flex rows, so
 * "Russian" landed at a different x-position in each one depending on how many counters its
 * neighbour happened to have. Three fixed columns line every language's name, bar and counters up
 * with the row above and below it, which is the whole of what "scan four languages at once" means.
 *
 * **The counters keep the fixed order untranslated → awaiting review → QA errors → unanswered →
 * machine, with zeros omitted rather than printed.** A reader who has learned that the second
 * counter in the row is always "awaiting review" when it appears at all does not have to re-read
 * the noun on every row; a reader given four different orders on four different rows does.
 *
 * **Every number goes somewhere.** `untranslated`, `awaitingReview` and `qaErrors` link to the exact
 * filtered queue that counter names — reading "12 QA errors" and then finding those twelve errors
 * used to be four navigations through an unfiltered editor. `blocked` and `machineUnreviewed` stay
 * plain because no page lists only those two, and a link that promises a filtered list and delivers
 * an unfiltered one is worse than no link. Same rule, same routes as the project page's own band.
 */
@Composable
private fun ReadinessLocaleRow(slug: String, locale: LocaleReadinessDto) {
    val palette = ColorMode.current.toSitePalette()
    val language = localeInfo(locale.locale).englishName
    // Blocked reading: an unanswered question or a QA error is the one thing a "Translate" click
    // cannot clear by itself, so it earns a mark a reader catches before reading the name.
    val flagged = locale.blocked > 0 || locale.qaErrors > 0
    Div(
        Modifier
            .fillMaxWidth()
            .styleModifier {
                property("display", "grid")
                property("grid-template-columns", "minmax(120px, 160px) minmax(140px, 1fr) minmax(0, auto)")
                property("column-gap", Space.MD.toString())
                property("row-gap", Space.XXS.toString())
                property("align-items", "center")
            }
            .toAttrs(),
    ) {
        Row(Modifier.gap(Space.XS).minWidth(0.px), verticalAlignment = Alignment.CenterVertically) {
            if (flagged) {
                val blockedTitle = t(
                    "app.index.blocked_on_a_question_or_a_qa",
                    "Blocked on a question or a QA error",
                )
                Span(
                    Modifier
                        .width(6.px)
                        .height(6.px)
                        .styleModifier { property("border-radius", "50%") }
                        .backgroundColor(palette.warning)
                        .toAttrs {
                            attr("aria-hidden", "true")
                            attr("title", blockedTitle)
                        },
                ) {}
            }
            Span(
                Modifier.fontSize(TypeScale.BodySmall).fontWeight(600).toAttrs(),
            ) { Text(language) }
            Span(
                Modifier.color(palette.textMuted).fontSize(TypeScale.Small).monoFont().toAttrs(),
            ) { Text(locale.locale) }
        }
        ReadinessLocaleBar(locale)
        if (locale.shippable) {
            LBadge(t("app.index.release_ready", "Release-ready"), variant = LBadgeVariant.SUCCESS)
        } else {
            Row(
                Modifier.gap(Space.MD).flexWrap(FlexWrap.Wrap),
                verticalAlignment = Alignment.CenterVertically,
            ) {
                LocaleCounter(
                    icon = { LLanguagesIcon() },
                    label = t("app.index.untranslated_2", "untranslated"),
                    value = locale.untranslated,
                    language = language,
                    href = "/app/projects/$slug/translate/${locale.locale}",
                )
                LocaleCounter(
                    icon = { LListChecksIcon() },
                    label = t("app.index.awaiting_review_2", "awaiting review"),
                    value = locale.awaitingReview,
                    language = language,
                    href = "/app/projects/$slug/review/${locale.locale}",
                )
                LocaleCounter(
                    icon = { LWarningIcon() },
                    label = t("app.index.qa_errors", "QA errors"),
                    value = locale.qaErrors,
                    language = language,
                    href = "/app/projects/$slug/qa?locale=${locale.locale}",
                )
                LocaleCounter(
                    icon = { LCommentIcon() },
                    label = t("app.index.unanswered", "unanswered"),
                    value = locale.blocked,
                    language = language,
                )
                LocaleCounter(
                    icon = { LBotIcon() },
                    label = t("app.index.machine_2", "machine"),
                    value = locale.machineUnreviewed,
                    language = language,
                )
            }
        }
    }
}

/**
 * The approved share, as one thin track rather than the twenty-cell bar the readiness band draws.
 *
 * `LProgressBar(compact = true)` — the same track the project's own progress list already draws for
 * a whole project — reused here at locale grain instead of a bespoke bar: the approved and
 * awaiting-review fills come from `ChartPalette.forState`, the same hue this dashboard already uses
 * for "translated" and "approved" everywhere else it draws either. The percentage beside it is the
 * *approved* share specifically, because "80% done" that counts unreviewed machine output the same
 * as a signed-off string is the exact claim [LocaleReadinessDto.shippable] refuses to make.
 */
@Composable
private fun ReadinessLocaleBar(locale: LocaleReadinessDto) {
    val palette = ColorMode.current.toSitePalette()
    val total = locale.total.coerceAtLeast(0)
    val approved = locale.approved.coerceIn(0, total)
    val awaitingReview = locale.awaitingReview.coerceIn(0, total - approved)
    val approvedPercent = if (total == 0) 0 else (approved * 100 / total)
    Row(Modifier.gap(Space.SM).minWidth(0.px), verticalAlignment = Alignment.CenterVertically) {
        LProgressBar(
            progress = LProgressCounts(total = total, translated = awaitingReview, approved = approved),
            modifier = Modifier.flexGrow(1).minWidth(48.px),
            label = trf(
                "app.index.language_release_readiness",
                "{language} release readiness",
                "language" to localeInfo(locale.locale).englishName,
            ),
            showCounts = false,
            compact = true,
        )
        Span(
            Modifier
                .minWidth(34.px)
                .tabularNumbers()
                .fontSize(TypeScale.Small)
                .fontWeight(600)
                .color(palette.textSecondary)
                .textAlign(TextAlign.End)
                .toAttrs(),
        ) { Text("$approvedPercent%") }
    }
}

/** One icon, one number, one short noun — and nothing at all when the number is zero. */
@Composable
private fun LocaleCounter(
    icon: @Composable () -> Unit,
    label: String,
    value: Int,
    language: String,
    href: String? = null,
) {
    // Zero is the good outcome and the row's bar and badge already say so. A zero repeated five
    // times per language is the noise this card exists to cut.
    if (value <= 0) return
    val palette = ColorMode.current.toSitePalette()
    val text = "$value $label"
    val content: @Composable () -> Unit = {
        Row(Modifier.gap(Space.XXS), verticalAlignment = Alignment.CenterVertically) {
            Span(
                Modifier
                    .iconSize(IconSize.XS)
                    .color(palette.textSecondary)
                    .styleModifier { property("display", "inline-flex") }
                    .toAttrs { attr("aria-hidden", "true") },
            ) { icon() }
            Span(
                Modifier.tabularNumbers().fontSize(TypeScale.Small).color(palette.textSecondary).toAttrs(),
            ) { Text(text) }
        }
    }
    if (href != null) {
        Link(
            path = href,
            modifier = PlainLinkStyle.toModifier().attr(
                "aria-label",
                trf(
                    "app.index.text_in_language",
                    "{text}, {language}",
                    "text" to text,
                    "language" to language,
                ),
            ),
        ) { content() }
    } else {
        content()
    }
}

/**
 * Credits, in three states, and only for the people who pay.
 *
 * A translator has no credit position — the block is absent rather than empty, because rendering
 * "couldn't load" at somebody who is not allowed the number tells them something is broken.
 *
 * The state that matters most is **nothing spent**, which is every new workspace: a bare
 * "0 of 2,000 credits used" is a fact nobody asked for, and the moment to say what credits are for
 * is the moment none have been used.
 */
@Composable
private fun CreditsSection(
    data: OverviewResponse,
    onNewProject: () -> Unit,
    onReload: () -> Unit,
    onNavigate: (String) -> Unit,
) {
    val credits = data.credits
    if (credits == null && "credits" !in data.failed) return

    Section(t("app.index.credits", "Credits"), { LCoinsIcon() }) {
        when {
            // The important partial failure: billing timing out must never blank the readiness
            // above it, so the retry lives in this block and nowhere else.
            credits == null -> BlockFailure(t("app.index.your_credit_position", "your credit position"), onReload)
            credits.included <= 0 -> SectionNote(
                headline = t("app.index.this_plan_includes_no_machine_translation", "This plan includes no machine translation credits."),
                detail = t("app.index.pre_translate_needs_credits_to_fill", "Pre-translate needs credits to fill a first draft. Everything else — " +
                    "the editor, QA, imports and exports — works without them."),
            ) {
                LButton(
                    label = t("app.index.see_plans", "See plans"),
                    onClick = { onNavigate("/app/settings/billing/plans") },
                    variant = LButtonVariant.SECONDARY,
                    size = LButtonSize.SM,
                )
            }
            credits.used == 0 -> {
                val first = data.projects.firstOrNull()
                SectionNote(
                    headline = t("app.index.nothing_spent_this_month", "Nothing spent this month."),
                    detail = tf(
                        "app.index.included_are_included_with_left_in",
                        "{included} are included, with {left} left in the period. " +
                        "Pre-translate spends them on a first draft that somebody then reviews.", "included" to countLabel(credits.included, "credit"), "left" to countLabel(credits.daysRemaining, "day")),
                ) {
                    // **`providerReady` decides whether machine translation may be offered at
                    // all** — its own KDoc says so. Without that gate this card offered to spend
                    // credits on pre-translation nine hundred pixels below the shell banner saying
                    // machine translation is off until a provider is connected. With a project and
                    // no provider the card states the credit position and offers nothing: the one
                    // action that would make these credits spendable is already on the banner, and
                    // a second copy of it here is the repetition this page exists to cut.
                    if (first != null && data.providerReady) {
                        // The real number, not the project's name: every automation label on this
                        // release states what it would act on, and the tile row directly above
                        // already knows the answer.
                        val untranslated = first.locales.sumOf(LocaleReadinessDto::untranslated)
                        LButton(
                            label = tPlural(
                                "app.index.count.pre_translate_untranslated",
                                untranslated,
                                "Pre-translate {count} untranslated",
                                "Pre-translate {count} untranslated",
                            ),
                            onClick = { onNavigate("/app/projects/${first.slug}/pretranslate") },
                            variant = LButtonVariant.SECONDARY,
                            size = LButtonSize.SM,
                            leadingIcon = { LSparkleIcon() },
                            // The visible label is the whole of the name's opening, which is what
                            // WCAG 2.5.3 asks of a speech user saying "click Pre-translate 100
                            // untranslated"; the project is what the visible label cannot fit.
                            accessibleLabel = tPlural(
                                "app.index.count.pre_translate_untranslated_in_name",
                                untranslated,
                                "Pre-translate {count} untranslated in {name}",
                                "Pre-translate {count} untranslated in {name}",
                                "name" to first.name,
                            ),
                        )
                    } else if (first == null) {
                        LButton(
                            label = t("app.index.new_project", "New project"),
                            onClick = onNewProject,
                            variant = LButtonVariant.SECONDARY,
                            size = LButtonSize.SM,
                            leadingIcon = { LPlusIcon() },
                        )
                    }
                }
            }
            else -> CreditPositionCard(credits) { onNavigate("/app/settings/billing") }
        }
    }
}

/** Used of included, and the date it runs out — the only two numbers that change a decision. */
@Composable
private fun CreditPositionCard(credits: CreditPositionDto, onOpen: () -> Unit) {
    val palette = ColorMode.current.toSitePalette()
    LCard(Modifier.fillMaxWidth()) {
        Row(
            Modifier.fillMaxWidth().gap(Space.MD).flexWrap(FlexWrap.Wrap),
            verticalAlignment = Alignment.CenterVertically,
        ) {
            Column(Modifier.flexGrow(1).styleModifier { property("flex-basis", "240px") }.minWidth(0.px).gap(Space.XS)) {
                Span(Modifier.tabularNumbers().fontWeight(600).toAttrs()) {
                    // Grouped, which is how this section's own KDoc writes the example — and how
                    // `Insights` writes the same figures. Ungrouped, "0 of 2000 credits used".
                    Text(
                        tf(
                            "app.index.used_of_included_credits_used",
                            "{used} of {included} credits used",
                            "used" to formatCount(credits.used),
                            "included" to formatCount(credits.included),
                        ),
                    )
                }
                Span(
                    Modifier.color(palette.textSecondary).fontSize(TypeScale.Small).toAttrs(),
                ) {
                    Text(
                        credits.exhaustionDate
                            ?.let {
                                tf(
                                    "app.index.at_this_rate_they_run_out",
                                    "At this rate they run out on {date}.",
                                    "date" to formatCalendarDate(it),
                                )
                            }
                            ?: tf(
                                "app.index.they_wont_run_out_this_month_count",
                                "They won't run out this month. {count} left in the period.",
                                "count" to countLabel(credits.daysRemaining, "day"),
                            ),
                    )
                }
            }
            LButton(
                label = t("app.index.billing", "Billing"),
                onClick = onOpen,
                variant = LButtonVariant.GHOST,
                size = LButtonSize.SM,
            )
        }
    }
}

/**
 * What happened, and the door to the rest of it.
 *
 * The eight rows here are a cap, not the whole log, and `/app/activity` renders the same sentences
 * from the same builder — so the link is a longer list, never a second account of the same events.
 */
@Composable
private fun RecentWorkSection(
    data: OverviewResponse,
    onReload: () -> Unit,
    onNavigate: (String) -> Unit,
) {
    Section(t("app.index.recent_work", "Recent work"), { LHistoryIcon() }) {
        when {
            "worklog" in data.failed -> BlockFailure(t("app.index.the_work_log", "the work log"), onReload)
            // Not the first-run empty: `isFirstRun` has already claimed the case where there are no
            // projects either, so reaching here means the projects exist and no work has landed in
            // them. The action is therefore the thing that produces the first entry.
            data.workLog.isEmpty() -> {
                val first = data.projects.firstOrNull()
                LEmptyState(
                    title = t("app.index.no_work_recorded_yet", "No work recorded yet"),
                    description = t("app.index.imports_translations_reviews_and_comments_show", "Imports, translations, reviews and comments show up here as " +
                        "sentences with real names in them. Bring your strings in and the log " +
                        "starts."),
                    modifier = Modifier.fillMaxWidth(),
                    icon = LEmptyStateIcon.REFRESH,
                ) {
                    if (first != null) {
                        // Secondary for the same reason the readiness empty state is: the
                        // dashboard's one accent belongs to the top attention card, and a section
                        // that happens to be empty is not the page's most important thing. On a
                        // workspace with projects and no activity this was the accent competing
                        // with the header's "New project" over a page nothing was pressing on.
                        LButton(
                            label = t("app.index.import_strings", "Import strings"),
                            onClick = { onNavigate("/app/projects/${first.slug}/data") },
                            variant = LButtonVariant.SECONDARY,
                        )
                    } else {
                        LButton(
                            label = t("app.index.see_all_projects", "See all projects"),
                            onClick = { onNavigate("/app/projects") },
                            variant = LButtonVariant.SECONDARY,
                        )
                    }
                }
            }
            else -> Column(Modifier.fillMaxWidth().gap(Space.MD)) {
                WorkLog(data.workLog, data.projects, onNavigate)
                Row(Modifier.fillMaxWidth().gap(Space.SM)) {
                    LButton(
                        label = t("app.index.see_all_activity", "See all activity"),
                        onClick = { onNavigate("/app/activity") },
                        variant = LButtonVariant.GHOST,
                        size = LButtonSize.SM,
                    )
                }
            }
        }
    }
}

/**
 * Eight sentences with real names in them. A log line tells nobody how the work is going.
 *
 * **Every row is its own link now.** It used to be a static row ending in a separate "Open" button —
 * five identical trailing controls, and the row itself did nothing when pressed. [WorkLogRowLinkStyle]
 * makes the whole row the control, so a pointer anywhere on it and a keyboard tab-stop both work, and
 * nothing announces "Open" a second time once the sentence already says what happened.
 *
 * [projects] resolves a project name for the events that name one; passed separately from [entries]
 * because the DTO carries only [WorkLogEntryDto.projectSlug], and the overview already has every
 * project's name in one place. Defaulted to empty so a caller with no project list — a future page
 * showing only the log — still renders the generic sentence every event carries.
 */
@Composable
internal fun WorkLog(
    entries: List<WorkLogEntryDto>,
    projects: List<OverviewProjectDto> = emptyList(),
    onNavigate: (String) -> Unit,
) {
    // Day headings only earn their place when the list actually spans more than one day — eight
    // rows from this morning gain nothing from a lone "Today" heading repeated over every one.
    val spansMultipleDays = entries.map(::workLogDayKey).toSet().size > 1
    var lastDayKey: String? = null
    LCard(Modifier.fillMaxWidth()) {
        Column(Modifier.fillMaxWidth()) {
            entries.forEachIndexed { index, entry ->
                val dayKey = workLogDayKey(entry)
                val newDay = spansMultipleDays && dayKey != lastDayKey
                if (newDay) {
                    Span(
                        Modifier
                            .color(ColorMode.current.toSitePalette().textMuted)
                            .fontSize(TypeScale.Small)
                            .fontWeight(600)
                            .styleModifier {
                                property("padding-block", "${if (index == 0) Space.XS else Space.MD} ${Space.XS}")
                            }
                            .toAttrs(),
                    ) { Text(workLogDayHeading(entry)) }
                }
                lastDayKey = dayKey
                WorkLogRow(entry, projectName(entry.projectSlug, projects), onNavigate)
                val next = entries.getOrNull(index + 1)
                // No divider immediately before a fresh day heading — the heading itself is the
                // separation, and a hairline right above it would be a second one.
                if (next != null && !(spansMultipleDays && workLogDayKey(next) != dayKey)) LDivider()
            }
        }
    }
}

/**
 * One event, as a single link: who, what happened, to what, and how long ago.
 *
 * A real `Link`, not a row with a click handler standing in for one — the same reason [LCardLink]
 * exists. `onNavigate` is unused here on purpose: it named the destination for the "Open" button
 * this row replaces, and a `Link` needs no such indirection to route in place.
 */
@Composable
private fun WorkLogRow(entry: WorkLogEntryDto, projectName: String?, onNavigate: (String) -> Unit) {
    val palette = ColorMode.current.toSitePalette()
    val actor = entry.actor
    val clause = actor?.let { workLogClause(entry, projectName) }
    Link(
        path = entry.href,
        modifier = WorkLogRowLinkStyle.toModifier(),
    ) {
        // Decorative: the sentence beside it already names the actor, so an avatar announcing
        // "Maya Chen avatar" a second time would say the name twice on every row.
        //
        // `actor.orEmpty()` falls back to `LAvatar`'s own "?" — reserved for a server that truly
        // sent no actor (a system action, or a deleted user), never for one it merely forgot to
        // put in this field. Recovering the name by parsing it back out of `sentence` lived here
        // once; it was the wrong layer, because `sentence` is prose a server may reword and will
        // not survive translation, while `sentenceFor` already holds the actor's display name at
        // the moment it writes that prose. The fix belongs where the name already is — `actor` is
        // now populated from that same value, for every row `sentenceFor` names one in.
        LAvatar(
            name = actor.orEmpty(),
            size = LAvatarSize.SM,
            modifier = Modifier.attr("aria-hidden", "true"),
        )
        ActivityGlyph(entry.type)
        Column(Modifier.flexGrow(1).minWidth(0.px).gap(Space.XXS)) {
            Span(Modifier.fontSize(TypeScale.BodySmall).toAttrs()) {
                if (actor != null && clause != null) {
                    Span(Modifier.fontWeight(600).toAttrs()) { Text(actor) }
                    Text(" $clause")
                } else {
                    Text(entry.sentence)
                }
            }
        }
        Span(
            Modifier
                .color(palette.textMuted)
                .fontSize(TypeScale.Small)
                .styleModifier { property("white-space", "nowrap") }
                .toAttrs(),
        ) { Text(formatRelativeTime(entry.at)) }
    }
}

/** The project this event happened in, by name, or null when the overview never sent that project. */
private fun projectName(slug: String?, projects: List<OverviewProjectDto>): String? =
    slug?.let { s -> projects.firstOrNull { it.slug == s }?.name }

/**
 * The verb and its object, in the reader's language, for the event kinds that have one.
 *
 * Deliberately not derived from [WorkLogEntryDto.sentence]: that string is prose the server already
 * built with the actor's name inside it, in whatever word order the *server's* language puts a
 * subject in — parsing it back apart to re-bold the name would break in every locale but English.
 * This instead reconstructs the clause from the same structured fields [entry] now carries
 * ([WorkLogEntryDto.locale], [WorkLogEntryDto.action]) plus [projectName], resolved from the
 * overview's own project list. Null for a kind this has no specific phrasing for, or for a kind that
 * needs an object this response did not resolve (an event on a project that has since scrolled off
 * the overview's capped list) — the caller falls back to [WorkLogEntryDto.sentence] either way.
 */
private fun workLogClause(entry: WorkLogEntryDto, projectName: String?): String? {
    val language = entry.locale?.let { localeInfo(it).englishName }
    return when (entry.type) {
        "FILE_IMPORTED" -> projectName?.let {
            trf("app.index.work_log_imported_translations_into", "imported translations into {name}", "name" to it)
        }
        "TRANSLATION_UPDATED" -> language?.let {
            trf("app.index.work_log_translated_in", "translated in {language}", "language" to it)
        }
        "TRANSLATION_REVIEWED" -> language?.let {
            when (entry.action) {
                "APPROVE" -> trf("app.index.work_log_approved_a_string_in", "approved a string in {language}", "language" to it)
                "REQUEST_CHANGES" -> trf("app.index.work_log_sent_a_string_back_in", "sent a string back in {language}", "language" to it)
                else -> trf("app.index.work_log_reviewed_a_string_in", "reviewed a string in {language}", "language" to it)
            }
        }
        "COMMENT_ADDED" -> when {
            language != null -> trf("app.index.work_log_commented_in_language", "commented in {language}", "language" to language)
            projectName != null -> trf("app.index.work_log_commented_in_name", "commented in {name}", "name" to projectName)
            else -> null
        }
        "MT_PRETRANSLATED", "MACHINE_TRANSLATION_SAVED" -> projectName?.let {
            trf("app.index.work_log_ran_a_pretranslate_in", "ran a pre-translate in {name}", "name" to it)
        }
        "MT_JOB_CANCELLED" -> projectName?.let {
            trf("app.index.work_log_cancelled_a_pretranslate_run_in", "cancelled a pre-translate run in {name}", "name" to it)
        }
        "KEY_CREATED" -> projectName?.let {
            trf("app.index.work_log_added_a_string_in", "added a string in {name}", "name" to it)
        }
        "KEY_UPDATED" -> projectName?.let {
            trf("app.index.work_log_changed_a_string_in", "changed a string in {name}", "name" to it)
        }
        "KEY_DELETED" -> projectName?.let {
            trf("app.index.work_log_removed_a_string_from", "removed a string from {name}", "name" to it)
        }
        "KEY_RESTORED" -> projectName?.let {
            trf("app.index.work_log_restored_a_string_in", "restored a string in {name}", "name" to it)
        }
        "LOCALE_ADDED" -> projectName?.let {
            trf("app.index.work_log_added_a_target_language_to", "added a target language to {name}", "name" to it)
        }
        "LOCALE_REMOVED" -> projectName?.let {
            trf("app.index.work_log_removed_a_target_language_from", "removed a target language from {name}", "name" to it)
        }
        "FILE_CREATED" -> projectName?.let {
            trf("app.index.work_log_added_a_file_to", "added a file to {name}", "name" to it)
        }
        "FILE_DELETED" -> projectName?.let {
            trf("app.index.work_log_removed_a_file_from", "removed a file from {name}", "name" to it)
        }
        "MEMBER_INVITED" -> projectName?.let {
            trf("app.index.work_log_invited_somebody_to", "invited somebody to {name}", "name" to it)
        }
        "MEMBER_REMOVED" -> projectName?.let {
            trf("app.index.work_log_removed_somebody_from", "removed somebody from {name}", "name" to it)
        }
        "MEMBER_ROLE_CHANGED" -> projectName?.let {
            trf("app.index.work_log_changed_a_role_in", "changed a role in {name}", "name" to it)
        }
        else -> null
    }
}

/** A stable key for the calendar day a work-log entry happened on, in the reader's own timezone. */
private fun workLogDayKey(entry: WorkLogEntryDto): String = workLogDayKey(entry.at)
private fun workLogDayKey(iso: String): String {
    val timestamp = Date.parse(iso)
    if (timestamp.isNaN()) return iso.take(10)
    val date = Date(timestamp)
    return workLogStartOfDay(date).getTime().toString()
}

/** "Today", "Yesterday", or the reader's own date format — never the raw ISO string. */
private fun workLogDayHeading(entry: WorkLogEntryDto): String {
    val timestamp = Date.parse(entry.at)
    if (timestamp.isNaN()) return entry.at.take(10)
    val day = workLogStartOfDay(Date(timestamp))
    val today = workLogStartOfDay(Date())
    val diffDays = ((today.getTime() - day.getTime()) / WORK_LOG_DAY_MS).roundToInt()
    return when (diffDays) {
        0 -> tr("app.index.today", "Today")
        1 -> tr("app.index.yesterday", "Yesterday")
        else -> Date(timestamp).toLocaleDateString()
    }
}

private const val WORK_LOG_DAY_MS = 24 * 60 * 60 * 1000.0

private fun workLogStartOfDay(date: Date): Date = Date(date.getFullYear(), date.getMonth(), date.getDate())

/**
 * The row link, as one control rather than a row ending in a separate "Open" button.
 *
 * Modelled on [LCardLinkStyle]'s own focus ring rather than a second one invented for this row: a
 * visible ring on keyboard focus, offset so it reads as a halo rather than a line through the row's
 * own content.
 */
val WorkLogRowLinkStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .gap(Space.MD)
            .styleModifier {
                property("display", "flex")
                property("align-items", "center")
                property("padding-block", Space.MD.toString())
                property("border-radius", Radius.Control.toString())
            }
            .textDecorationLine(TextDecorationLine.None)
            .styleModifier { property("color", "inherit") }
            .transitionColors()
    }
    hover {
        Modifier.backgroundColor(colorMode.toSitePalette().surfaceSunken)
    }
    focusVisible {
        Modifier
            .outline(2.px, LineStyle.Solid, colorMode.toSitePalette().accent)
            .styleModifier { property("outline-offset", "-2px") }
    }
}

/**
 * One block could not be computed, and only that block says so.
 *
 * A billing timeout must never blank the overview — the page a customer opens most often failing
 * entirely because one query was slow is strictly worse than the slow page it replaced.
 */
@Composable
private fun BlockFailure(what: String, onRetry: () -> Unit) {
    LCard(Modifier.fillMaxWidth()) {
        Row(
            Modifier.fillMaxWidth().gap(Space.MD).flexWrap(FlexWrap.Wrap),
            verticalAlignment = Alignment.CenterVertically,
        ) {
            Span(Modifier.flexGrow(1).styleModifier { property("flex-basis", "240px") }.minWidth(0.px).fontSize(TypeScale.BodySmall).toAttrs()) {
                Text(
                    tf(
                        "app.index.couldnt_load_what_everything_else_on",
                        "Couldn't load {what}. Everything else on this page is current.",
                        "what" to what,
                    ),
                )
            }
            // Four of these can be on the page at once — attention, readiness, credits, the work
            // log — and as four buttons named "Retry" a screen reader offers four identical
            // choices. The sentence that tells them apart is the sibling span, which is not part
            // of any of their names. The page already does this correctly for project and log
            // links; this block was the exception.
            LButton(
                label = t("app.index.retry", "Retry"),
                onClick = onRetry,
                variant = LButtonVariant.SECONDARY,
                size = LButtonSize.SM,
                accessibleLabel = tf("app.index.retry_loading_what", "Retry loading {what}", "what" to what),
            )
        }
    }
}

@Composable
internal fun ProjectCard(
    project: ProjectSummaryDto,
    lastActivity: ActivityDto?,
    onOpen: () -> Unit,
    /** Where the card's overflow menu sends the reader. */
    onNavigate: (String) -> Unit,
    /**
     * Position in its grid, so a list of these assembles rather than appearing all at once.
     *
     * Null for a grid that is no longer arriving. The projects page's live filter passes null once
     * somebody has typed in it: recreating a card it dropped must not restage the whole page.
     */
    index: Int? = 0,
) {
    val progress = project.progress.filterNot { it.locale == project.sourceLocale }
    LCard(
        Modifier
            .fillMaxWidth()
            .then(index?.let { Modifier.enterStaggered(it) } ?: Modifier)
            .styleModifier {
                property("display", "flex")
                property("flex-direction", "column")
                property("gap", Space.LG.toString())
            },
    ) {
        Row(Modifier.fillMaxWidth().gap(Space.MD), verticalAlignment = Alignment.CenterVertically) {
            ProjectIcon(
                slug = project.slug,
                name = project.name,
                iconKey = project.iconKey,
                accentKey = project.accentKey,
                hasCustomIcon = project.hasCustomIcon,
            )
            Column(Modifier.flexGrow(1).gap(Space.XS)) {
                H2(
                    Modifier
                        .displayFont()
                        .fontSize(TypeScale.HeadingSmall)
                        .fontWeight(700)
                        .lineHeight(TypeScale.DisplayLineHeight)
                        .margin(0.px)
                        .toAttrs(),
                ) {
                    Text(project.name)
                }
                Span(
                    Modifier
                        .color(ColorMode.current.toSitePalette().textMuted)
                        .fontSize(TypeScale.Small)
                        .toAttrs(),
                ) {
                    Text("${countLabel(project.keyCount, "key")} · ${countLabel(project.fileCount, "file")}")
                }
            }
            // The catalogue's word for the kind, not the enum constant with its underscores
            // lower-cased. "MOBILE_APP" rendered as "Mobile_app" in every language.
            LBadge(project.kind.displayLabel())
        }

        Column(Modifier.fillMaxWidth().gap(Space.MD)) {
            progress.forEach { localeProgress ->
                val locale = localeInfo(localeProgress.locale)
                Column(Modifier.fillMaxWidth().gap(Space.XS)) {
                    Row(
                        Modifier.fillMaxWidth().gap(Space.SM),
                        verticalAlignment = Alignment.CenterVertically,
                    ) {
                        Span(
                            Modifier
                                .flexGrow(1)
                                .color(ColorMode.current.toSitePalette().textSecondary)
                                .fontSize(TypeScale.Small)
                                .fontWeight(600)
                                .toAttrs(),
                        ) {
                            Text("${localeFlagPrefix(locale.code)}${locale.englishName}")  // i18n-ignore — a flag glyph immediately followed by a language name — no separator, no words, nothing a translator could change
                        }
                        // **The count is printed once, by the bar that owns it.** This span said
                        // "9 left" in JetBrains Mono at Micro and `ProgressCell`'s own trailing
                        // label said "9 left" eight pixels to its right in Instrument Sans at
                        // Small/600 — one fact in two phrasings, four times per card. The mono face
                        // was wrong here besides: DESIGN reserves it for key names, placeholders,
                        // paths and locale codes, not counts.
                    }
                    ProgressCell(localeProgress)
                }
            }
            if (progress.isEmpty()) {
                P(
                    Modifier
                        .color(ColorMode.current.toSitePalette().textMuted)
                        .fontSize(TypeScale.Small)
                        .margin(0.px)
                        .toAttrs(),
                ) {
                    Text(t("app.index.add_a_target_language_to_begin", "Add a target language to begin tracking progress."))
                }
            }
        }

        LDivider()
        Row(Modifier.fillMaxWidth().gap(Space.MD), verticalAlignment = Alignment.CenterVertically) {
            Span(
                Modifier
                    .flexGrow(1)
                    .color(ColorMode.current.toSitePalette().textMuted)
                    .fontSize(TypeScale.Small)
                    .toAttrs(),
            ) {
                val timestamp = lastActivity?.createdAt ?: project.updatedAt
                Text(
                    if (lastActivity == null) {
                        tf("app.index.updated_age", "Updated {age}", "age" to formatRelativeTime(timestamp))
                    } else {
                        tf("app.index.last_activity_age", "Last activity {age}", "age" to formatRelativeTime(timestamp))
                    },
                )
            }
            LButton(
                t("app.index.open_project", "Open project"),
                onOpen,
                variant = LButtonVariant.SECONDARY,
                size = LButtonSize.SM,
                accessibleLabel = tf("app.index.open_name", "Open {name}", "name" to project.name),
            )
            // The same menu the dashboard's readiness card carries, so the two surfaces offer the
            // same verbs for the same project. The counts this card holds are per-locale progress
            // rather than readiness, so only "untranslated" is real here — the review and QA
            // entries stay absent rather than guessing.
            ProjectActionMenu(
                facts = ProjectMenuFacts(
                    slug = project.slug,
                    name = project.name,
                    worstLocale = progress.minByOrNull { it.percentTranslated }?.locale,
                    untranslated = progress
                        .minByOrNull { it.percentTranslated }
                        ?.let { (it.total - it.translated).coerceAtLeast(0) }
                        ?: 0,
                ),
                onNavigate = onNavigate,
            )
        }
    }
}

/**
 * The design system's section heading, carrying this page's own weight and size.
 *
 * The markup was identical and written twice — here and in `Insights` — so a correction to the
 * product's section headings could only ever reach one page at a time. [LSectionTitle] resets the
 * user agent's margin itself; everything else is this page's display-font decision, unchanged.
 */
@Composable
private fun SectionTitle(title: String, icon: (@Composable () -> Unit)? = null) {
    LSectionTitle(
        title,
        Modifier
            .displayFont()
            .fontSize(TypeScale.HeadingSmall)
            .fontWeight(700)
            .lineHeight(TypeScale.DisplayLineHeight),
        icon = icon,
    )
}

/**
 * The mark beside one work-log row, chosen by what happened.
 *
 * **The defect this fixes.** Every row in the log drew [LHistoryIcon] — twenty identical marks
 * above twenty sentences, which is exactly as scannable as no marks at all, and a whole column of
 * pixels spent saying "this is history" to somebody reading a page called Recent work.
 *
 * Drawn from the stored constant [WorkLogEntryDto.type], never from the sentence built out of it.
 * Matching on prose would make the glyph vanish the moment somebody reworded "imported translations
 * into", and would leave every reader outside English with no marks at all.
 *
 * The same `when` arms as [activityLabel], in the same order and with the same fallthroughs, so a
 * type that gains a word here gains a mark there. The specific arms come before the family ones —
 * a restore is a key event and a cancellation is a machine event, and both have something more
 * useful to say than their family does. `null`, and anything this build has never heard of, keeps
 * the generic history mark: an unknown event did happen, and that is all it can honestly claim.
 *
 * `aria-hidden`, always. The sentence beside it already says what happened, and a screen reader
 * announcing "upload" before "Ada imported translations into Atlas" is one more thing to skip on
 * every row of a twenty-five row list. `LIcon` sets that attribute on every glyph it draws; the
 * wrapper states it again so a mark that is one day not an `LIcon` cannot leak into the log's
 * announcement by inheriting nothing.
 */
@Composable
internal fun ActivityGlyph(type: String?) {
    Div(
        Modifier
            // `textSecondary`, not `textMuted`: the recent-work row now carries an avatar too, and
            // at `textMuted` beside a solid-toned avatar the kind mark read as decoration nobody
            // needed to look at rather than the one thing on the row that tells five rows apart.
            .color(ColorMode.current.toSitePalette().textSecondary)
            .styleModifier { property("display", "inline-flex") }
            .toAttrs { attr("aria-hidden", "true") },
    ) {
        when {
            type == null -> LHistoryIcon()
            type == "FILE_IMPORTED" -> LUploadIcon()
            type == "TRANSLATION_UPDATED" -> LGlobeIcon()
            type == "TRANSLATION_REVIEWED" -> LCircleCheckIcon()
            type in setOf("COMMENT_ADDED", "COMMENT_RESOLVED", "COMMENT_REOPENED") -> LCommentIcon()
            type == "KEY_RESTORED" -> LArchiveRestoreIcon()
            type == "MT_JOB_CANCELLED" -> LCircleXIcon()
            type.startsWith("MT_") || type == "MACHINE_TRANSLATION_SAVED" -> LSparkleIcon()
            type.startsWith("KEY_") -> LKeyIcon()
            type.startsWith("LOCALE_") -> LLanguagesIcon()
            type.startsWith("FILE_") -> LFileIcon()
            else -> LHistoryIcon()
        }
    }
}

/**
 * A stored activity type, said in words.
 *
 * `tr` rather than [t]: this is a plain function called from row builders outside composition. Every
 * one of these was a bare English literal, so the one column a reader scans to find what happened
 * was English in every locale.
 */
internal fun activityLabel(type: String): String = when (type) {
    "LOCALE_ADDED" -> tr("app.index.target_language_added", "Target language added")
    "LOCALE_REMOVED" -> tr("app.index.target_language_removed", "Target language removed")
    "FILE_CREATED" -> tr("app.index.localization_file_added", "Localization file added")
    "FILE_DELETED" -> tr("app.index.localization_file_removed", "Localization file removed")
    "FILE_IMPORTED" -> tr("app.index.translations_imported", "Translations imported")
    "KEY_CREATED" -> tr("app.index.translation_key_created", "Translation key created")
    "KEY_UPDATED" -> tr("app.index.translation_key_updated", "Translation key updated")
    "KEY_DELETED" -> tr("app.index.translation_key_removed", "Translation key removed")
    "TRANSLATION_UPDATED" -> tr("app.index.translation_updated", "Translation updated")
    "COMMENT_ADDED" -> tr("app.index.comment_added", "Comment added")
    "COMMENT_RESOLVED" -> tr("app.index.comment_resolved", "Comment resolved")
    "COMMENT_REOPENED" -> tr("app.index.comment_reopened", "Comment reopened")
    "MT_PRETRANSLATED", "MACHINE_TRANSLATION_SAVED" -> tr("app.index.machine_translation_completed", "Machine translation completed")
    // The three the server started recording in this release. Without them the busiest column on
    // the activity list fell through to the `else` and read "Mt job cancelled" — the stored
    // constant with its underscores swapped for spaces, in every language.
    "MT_JOB_CANCELLED" -> tr("app.index.machine_translation_cancelled", "Machine translation cancelled")
    "TRANSLATION_REVIEWED" -> tr("app.index.translation_reviewed", "Translation reviewed")
    "KEY_RESTORED" -> tr("app.index.translation_key_restored", "Translation key restored")
    // Unknown to this build: a readable shape of the stored name rather than a key nobody can read.
    else -> type.lowercase().replace('_', ' ').replaceFirstChar { it.uppercase() }
}

/**
 * How long ago, in the reader's language.
 *
 * Delegates rather than implements. This was a byte-for-byte copy of [formatUtc]'s `AGE` style,
 * translated into a second set of catalogue keys — so "{count} min ago" appeared twice in `en.json`
 * and a translator could render the overview and the inbox differently without either being wrong.
 * The design system's copy survived because it also gets a future timestamp right, showing a date
 * rather than claiming "just now" for something that has not happened.
 */
internal fun formatRelativeTime(value: String): String = formatUtc(value, LTimeStyle.AGE, value)

/**
 * A server date said the way the reader writes dates.
 *
 * `CreditPositionDto.exhaustionDate` is documented as "an ISO date rather than a sentence, so the
 * client can say it in the reader's own format" — and the client printed it verbatim, so the one
 * sentence on this page about running out of money read "…run out on 2026-09-28". Falls back to the
 * raw string when the value will not parse, which is the same contract [formatRelativeTime] keeps:
 * a date the client cannot read is still better than no date.
 */
internal fun formatCalendarDate(value: String): String {
    val timestamp = Date.parse(value)
    return if (timestamp.isNaN()) value else Date(timestamp).toLocaleDateString()
}

/**
 * A counted noun, in the reader's own plural rules.
 *
 * This concatenated `"s"` — English's rule applied to every language, on the overview of a product
 * whose first-run copy sells "real plurals". Each noun now carries its own catalogue key so a
 * translator can supply however many forms their language needs, and [tPlural] asks the browser
 * which one a given count selects.
 *
 * The keys are spelled out rather than built from [noun]: a key assembled at runtime is invisible to
 * `extract-strings.mjs`, so it would never reach the catalogue and could never be translated — a
 * plural helper nobody can translate is the original bug with more steps.
 */
internal fun countLabel(count: Int, noun: String): String = when (noun) {
    "item" -> tPlural("app.index.count.item", count, "{count} item", "{count} items")
    "project" -> tPlural("app.index.count.project", count, "{count} project", "{count} projects")
    "language" -> tPlural("app.index.count.language", count, "{count} language", "{count} languages")
    "string" -> tPlural("app.index.count.string", count, "{count} string", "{count} strings")
    "credit" -> tPlural("app.index.count.credit", count, "{count} credit", "{count} credits")
    "day" -> tPlural("app.index.count.day", count, "{count} day", "{count} days")
    "key" -> tPlural("app.index.count.key", count, "{count} key", "{count} keys")
    "file" -> tPlural("app.index.count.file", count, "{count} file", "{count} files")
    // Unreachable for the nouns this page uses; kept honest rather than throwing on a new one.
    else -> "$count ${if (count == 1) noun else "${noun}s"}"
}

/**
 * What a brand-new workspace shows instead of an empty list.
 *
 * **This is the most important state on the page, not its fallback.** It is what every customer sees
 * first, and a localization tool with nothing in it cannot demonstrate anything — the editor is
 * blank, QA has nothing to flag, and progress is 0% of nothing. So it offers two routes rather than
 * one: bring your own strings, or load a worked example and look around first. The second is what
 * most people want and almost no tool offers.
 *
 * The sample lands in *this* workspace, not a shared demo login, so it can be edited, broken and
 * deleted without affecting anyone else.
 *
 * The third row is quieter on purpose and exists for the two people the two big doors do not fit:
 * somebody who was invited to a colleague's workspace and is looking at the wrong one, and somebody
 * who came to connect a repository rather than to click anything here.
 */
@Composable
private fun FirstRun(
    canManageProjects: Boolean,
    workspaceContext: WorkspaceRequestContext?,
    createAllowed: Boolean,
    onNewProject: () -> Unit,
    onOpenProject: (String) -> Unit,
    onNavigate: (String) -> Unit,
) {
    val scope = rememberCoroutineScope()
    var loading by remember(workspaceContext) { mutableStateOf(false) }
    var failure by remember(workspaceContext) { mutableStateOf<String?>(null) }
    val sampleClaim = WorkspaceActionClaim.capture(workspaceContext, WorkspacePrivilege.SAMPLE_PROJECT)
    val sampleTargetsThisWorkspace = workspaceContext?.decision(WorkspaceRequestKind.SAMPLE_PROJECT)?.allowed == true

    Column(Modifier.fillMaxWidth().gap(Space.LG)) {
        Div(FirstRunGridStyle.toModifier().toAttrs()) {
            FirstRunChoice(
                eyebrow = t("app.index.recommended", "Recommended"),
                title = t("app.index.explore_a_sample_project", "Explore a sample project"),
                description = t("app.index.five_locales_real_plurals_and_a", "Five locales, real plurals and a few deliberate QA problems to find. " +
                    "It lands in your workspace, so you can edit or delete it freely."),
                action = {
                    // **"Loading a sample requires project-management access and one unambiguous
                    // workspace"** was one sentence for two unrelated refusals, in vocabulary
                    // nobody outside this repository uses, and it named nothing the reader could do
                    // about either of them.
                    when {
                        !canManageProjects -> LAlert(
                            t("app.index.only_an_owner_or_an_admin", "Only an owner or an admin can add a project"),
                            t("app.index.ask_one_of_them_to_load", "Ask one of them to load the sample, or open a project that is already " +
                                "shared with you."),
                            variant = LAlertVariant.INFO,
                        )
                        !sampleTargetsThisWorkspace -> LAlert(
                            t("app.index.the_sample_cannot_pick_a_workspace", "Sample setup is unavailable here"),
                            t("app.index.you_are_in_more_than_one", "You can still explore an existing project or start with your own strings."),
                            variant = LAlertVariant.INFO,
                        )
                        else -> LButton(
                            label = t("app.index.load_sample_project", "Load sample project"),
                            onClick = {
                                if (loading) return@LButton
                                val claim = sampleClaim ?: return@LButton
                                loading = true
                                failure = null
                                scope.launch {
                                    runWorkspaceAction(
                                        claim, WorkspaceRequestContext::current,
                                        setBusy = { loading = it },
                                        transport = { ApiClient.createSampleProject(it) },
                                        onSuccess = { onOpenProject(it.slug) },
                                        onFailure = { error ->
                                            failure = (error as? ApiException)?.message ?: tr("app.index.couldnt_reach_lingvo_check_your_connection", "Couldn't reach Lingvo. Check your connection and retry.")
                                        },
                                    )
                                }
                            },
                            enabled = !loading,
                            loading = loading,
                            leadingIcon = { LSparkleIcon() },
                        )
                    }
                },
            )
            if (createAllowed) {
                FirstRunChoice(
                    eyebrow = t("app.index.your_own_strings", "Your own strings"),
                    title = t("app.index.start_a_project", "Start a project"),
                    description = t("app.index.choose_a_source_and_target_languages", "Choose a source and target languages, then push your files with " +
                        "the CLI or bring them in from the browser."),
                    action = {
                        LButton(
                            label = t("app.index.new_project", "New project"),
                            onClick = onNewProject,
                            variant = LButtonVariant.SECONDARY,
                            leadingIcon = { LPlusIcon() },
                        )
                    },
                )
            } else {
                FirstRunChoice(
                    eyebrow = t("app.index.workspace_access", "Workspace access"),
                    title = t("app.index.work_with_an_existing_project", "Work with an existing project"),
                    // For a translator the reason is their role, not the workspace — and the
                    // workspace sentence sent them to ask an admin about something that is fine.
                    description = if (!canManageProjects) {
                        t("app.index.your_role_in_this_workspace_does", "Your role in this workspace does not include creating projects. An " +
                            "owner or an admin can add one, or change your role. You can still " +
                            "open any project shared with you.")
                    } else {
                        t("app.index.this_server_cannot_yet_say_which", "This server cannot yet say which workspace a new project belongs " +
                            "to, so it refuses while you are in more than one. You can still open " +
                            "any project shared with you.")
                    },
                    action = {
                        LButton(
                            label = t("app.index.view_projects", "View projects"),
                            onClick = { onNavigate("/app/projects") },
                            variant = LButtonVariant.SECONDARY,
                        )
                    },
                )
            }
        }
        failure?.let { message ->
            LAlert(
                title = t("app.index.couldnt_create_the_sample", "Couldn't create the sample"),
                description = message,
                modifier = Modifier.fillMaxWidth(),
                variant = LAlertVariant.DANGER,
                // Fires on pressing "Load sample project" — the first thing a new workspace does.
                live = true,
            )
        }
        WhatThisPageBecomes()
        Row(Modifier.fillMaxWidth().gap(Space.SM).flexWrap(FlexWrap.Wrap)) {
            LButton(
                label = t("app.index.other_ways_to_start", "Other ways to start"),
                onClick = { onNavigate("/app/start") },
                variant = LButtonVariant.GHOST,
                size = LButtonSize.SM,
            )
            LButton(
                label = t("app.index.switch_workspace", "Switch workspace"),
                onClick = { onNavigate("/app/workspaces") },
                variant = LButtonVariant.GHOST,
                size = LButtonSize.SM,
            )
        }
    }
}

/**
 * What the four empty blocks under this will hold once there is work.
 *
 * An empty page that only says "no projects" spends the one moment the product has to explain
 * itself on an apology. This is the same four sections in the same order the page draws them, so
 * arriving here twice — once empty, once full — is arriving at the same page.
 */
@Composable
private fun WhatThisPageBecomes() {
    val palette = ColorMode.current.toSitePalette()
    LCard(Modifier.fillMaxWidth()) {
        Column(Modifier.fillMaxWidth().gap(Space.MD)) {
            Span(
                Modifier
                    .color(palette.textSecondary)
                    .fontSize(TypeScale.Micro)
                    .fontWeight(600)
                    .styleModifier {
                        property("text-transform", "uppercase")
                        property("letter-spacing", TypeScale.MicroTracking.toString())
                    }
                    .toAttrs(),
            ) { Text(t("app.index.once_there_is_work_this_page", "Once there is work, this page shows")) }
            PageBlockNote(
                t("app.index.needs_your_attention", "Needs your attention"),
                t("app.index.one_thing_to_do_at_a", "One thing to do at a time, each with a verb on it. Never a chart."),
            )
            PageBlockNote(
                t("app.index.release_readiness", "Release readiness"),
                t("app.index.how_far_each_language_is_from", "How far each language is from shippable, counted rather than averaged " +
                    "into a percentage."),
            )
            PageBlockNote(
                t("app.index.credits", "Credits"),
                t("app.index.what_machine_translation_has_cost_this", "What machine translation has cost this month, and the day it runs out " +
                    "at this rate."),
            )
            PageBlockNote(
                t("app.index.recent_work", "Recent work"),
                t("app.index.who_did_what_as_sentences_with", "Who did what, as sentences with real names in them."),
            )
        }
    }
}

@Composable
private fun PageBlockNote(title: String, detail: String) {
    val palette = ColorMode.current.toSitePalette()
    Column(Modifier.fillMaxWidth().gap(Space.XXS)) {
        Span(Modifier.fontSize(TypeScale.BodySmall).fontWeight(600).toAttrs()) { Text(title) }
        Span(
            Modifier
                .color(palette.textSecondary)
                .fontSize(TypeScale.Small)
                .lineHeight(TypeScale.BodyLineHeight)
                .toAttrs(),
        ) { Text(detail) }
    }
}

@Composable
private fun FirstRunChoice(
    eyebrow: String,
    title: String,
    description: String,
    action: @Composable () -> Unit,
) {
    val palette = ColorMode.current.toSitePalette()
    LCard(Modifier.fillMaxWidth()) {
        Column(Modifier.fillMaxWidth().gap(Space.SM)) {
            Span(
                Modifier
                    .color(palette.accent)
                    .fontSize(TypeScale.Micro)
                    .fontWeight(600)
                    .styleModifier {
                        property("text-transform", "uppercase")
                        property("letter-spacing", TypeScale.MicroTracking.toString())
                    }
                    .toAttrs(),
            ) { Text(eyebrow) }
            // `H2`, not a styled `Span`. On the populated page every section carries one; on first
            // run — the state that decides whether somebody stays — the two primary choices were
            // spans, so the most important screen in the product shipped with a single heading and
            // no way to move between its parts.
            H2(
                Modifier
                    .displayFont()
                    .margin(0.px)
                    .fontSize(TypeScale.HeadingSmall)
                    .fontWeight(700)
                    .toAttrs(),
            ) { Text(title) }
            Span(
                Modifier
                    .color(palette.textSecondary)
                    .fontSize(TypeScale.BodySmall)
                    .lineHeight(TypeScale.BodyLineHeight)
                    .toAttrs(),
            ) { Text(description) }
            Div(Modifier.padding(top = Space.SM).toAttrs()) { action() }
        }
    }
}

val FirstRunGridStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .gap(Space.LG)
            .styleModifier {
                property("display", "grid")
                property("grid-template-columns", "minmax(0, 1fr)")
                property("align-items", "start")
            }
    }
    Breakpoint.MD {
        Modifier.styleModifier { property("grid-template-columns", "repeat(2, minmax(0, 1fr))") }
    }
}
